import { useCallback, useEffect, useState } from "react";
import supportService from "../api/services/supportService";
import { getSupportSocket } from "../api/services/supportSocket";

/**
 * Live count of unclaimed / Available support tickets (PENDING + unassigned).
 */
export default function useUnclaimedSupportCount(enabled = true) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await supportService.getUnclaimedCount();
      setCount(Number(data?.total) || 0);
    } catch {
      // keep last known
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    refresh();

    const socket = getSupportSocket();
    const onCount = (payload = {}) => {
      if (typeof payload.total === "number") {
        setCount(Math.max(0, Number(payload.total) || 0));
        return;
      }
      refresh();
    };
    const onNew = () => {
      setCount((prev) => prev + 1);
      refresh();
    };
    const onAssigned = () => {
      setCount((prev) => Math.max(0, prev - 1));
      refresh();
    };
    const onAlert = (alert) => {
      if (alert?.type === "support_ticket") {
        setCount((prev) => prev + 1);
        refresh();
      }
    };

    socket.on("supportUnclaimedCountUpdated", onCount);
    socket.on("supportTicketNew", onNew);
    socket.on("supportTicketAssigned", onAssigned);
    socket.on("adminAlert", onAlert);

    const interval = window.setInterval(refresh, 30000);

    return () => {
      socket.off("supportUnclaimedCountUpdated", onCount);
      socket.off("supportTicketNew", onNew);
      socket.off("supportTicketAssigned", onAssigned);
      socket.off("adminAlert", onAlert);
      window.clearInterval(interval);
    };
  }, [enabled, refresh]);

  return count;
}
